export default __webpack_public_path__ + "static/media/Rectangle.c9c9e8a6.png";